import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout, retry, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { DrVideoRequest } from '../models/dr-video-request.model';
import { DrVideoResponse } from '../models/dr-video-response.model';

@Injectable({
  providedIn: 'root'
})
export class RequestsService {
  private apiUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) { }

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('accessToken') || '';
    return new HttpHeaders({ Authorization: token, 'Content-Type': 'application/json' });
  }

  private getCognitoId(): string {
    return localStorage.getItem('cognito') || '';
  }

  private overridePolizaKey(data: any): void {
    if (data && data.petition) {
      const selectedPoliza = localStorage.getItem('selectedPoliza');
      if (selectedPoliza) {
        try {
          const poliza = JSON.parse(selectedPoliza);
          if (data.petition.key) {
            data.petition.key = poliza.insurance;
          }
        } catch (e) {
          console.warn('Error parsing selectedPoliza:', e);
        }
      }
    }
  }

  sendAmbulanceRequest(data: any): Observable<any> {
    const url = `${this.apiUrl}/file/${this.getCognitoId()}/add`;
    this.overridePolizaKey(data);
    return this.http.post<any>(url, data, { headers: this.getHeaders() });
  }

  sendSubserviceRequest(data: any, subserviceId: number): Observable<any> {
    const url = `${this.apiUrl}/user/${this.getCognitoId()}/subservices/${subserviceId}`;
    return this.http.post<any>(url, data, { headers: this.getHeaders() });
  }

  sendSegundaOpinionRequest(data: any): Observable<any> {
    const url = `${this.apiUrl}/file/${this.getCognitoId()}/add`;
    this.overridePolizaKey(data);
    return this.http.post<any>(url, data, { headers: this.getHeaders() });
  }

  sendMedicaTelefonicaRequest(data: any): Observable<any> {
    const url = `${this.apiUrl}/file/${this.getCognitoId()}/add`;
    this.overridePolizaKey(data);
    return this.http.post<any>(url, data, { headers: this.getHeaders() });
  }

  sendMedicalReferencesRequest(data: any): Observable<any> {
    const url = `${this.apiUrl}/file/${this.getCognitoId()}/add`;
    this.overridePolizaKey(data);
    return this.http.post<any>(url, data, { headers: this.getHeaders() });
  }

  sendUrgentMessagesRequest(data: any): Observable<any> {
    const url = `${this.apiUrl}/file/${this.getCognitoId()}/add`;
    this.overridePolizaKey(data);
    return this.http.post<any>(url, data, { headers: this.getHeaders() });
  }

  sendHomeDoctorRequest(data: any): Observable<any> {
    const url = `${this.apiUrl}/file/${this.getCognitoId()}/add`;
    this.overridePolizaKey(data);
    return this.http.post<any>(url, data, { headers: this.getHeaders() });
  }

  sendDiscountNetworkRequest(data: any): Observable<any> {
    const url = `${this.apiUrl}/file/${this.getCognitoId()}/add`;
    this.overridePolizaKey(data);
    return this.http.post<any>(url, data, { headers: this.getHeaders() });
  }

  sendMedicalCheckupRequest(data: any): Observable<any> {
    const url = `${this.apiUrl}/file/${this.getCognitoId()}/add`;
    this.overridePolizaKey(data);
    return this.http.post<any>(url, data, { headers: this.getHeaders() });
  }

  getAssistanceDetails(clExpediente: string): Observable<any> {
    const url = `${this.apiUrl}/file/${this.getCognitoId()}/details/${clExpediente}`;
    return this.http.get<any>(url, { headers: this.getHeaders() });
  }

  sendFunerariaRequest(data: any): Observable<any> {
    const url = `${this.apiUrl}/file/${this.getCognitoId()}/add`;
    this.overridePolizaKey(data);
    return this.http.post<any>(url, data, { headers: this.getHeaders() });
  }

  sendLegalFunerariaRequest(data: any): Observable<any> {
    const url = `${this.apiUrl}/file/${this.getCognitoId()}/add`;
    this.overridePolizaKey(data);
    return this.http.post<any>(url, data, { headers: this.getHeaders() });
  }

  sendDefaultClickToCallRequest(data: any): Observable<any> {
    const url = `${this.apiUrl}/file/${this.getCognitoId()}/add`;
    this.overridePolizaKey(data);
    return this.http.post<any>(url, data, { headers: this.getHeaders() });
  }

  getServicesCommons(): Observable<any> {
    const account = localStorage.getItem('account') || '';
    const url = `${this.apiUrl}/user/${this.getCognitoId()}/services/${account}/-1/commons`;
    return this.http.get<any>(url, { headers: this.getHeaders() });
    
  }

  findLaboratories(requestData: any): Observable<any> {
    const url = `${this.apiUrl}/labs/${this.getCognitoId()}/find`;
    console.log('🔍 findLaboratories - URL:', url);
    console.log('🔍 findLaboratories - Request:', requestData);
    
    return this.http.post<any>(url, requestData, { headers: this.getHeaders() })
      .pipe(
        timeout(50000), // 50 segundos timeout máximo
        retry(1), // Reintentar una vez
        catchError(error => {
          console.error('❌ findLaboratories error:', error);
          if (error.name === 'TimeoutError') {
            return of({ success: false, data: [], error: 'timeout', message: 'El servicio tardó demasiado en responder' });
          }
          return of({ success: false, data: [], error: error.message || 'Error desconocido' });
        })
      );
  }

  getMedicalCheckupPdf(clExpediente: string): Observable<any> {
    const url = `${this.apiUrl}/checkUp/${this.getCognitoId()}/getBase64Pdf`;
    return this.http.post<any>(url, { clExpediente }, { headers: this.getHeaders() });
  }

  getCheckupCatalog(account: number): Observable<any> {
    const url = `${this.apiUrl}/checkUp/${this.getCognitoId()}/catalogEstudies/${account}`;
    return this.http.get<any>(url, { headers: this.getHeaders() });
  }

  sendCheckupWA(data: any): Observable<any> {
    const cognitoId = this.getCognitoId();
    const url = `${this.apiUrl}/checkUp/${cognitoId}/checkUpWA`;
    const headers = this.getHeaders();
    return this.http.post<any>(url, data, { headers });
  }

  saveCheckUp(data: any): Observable<any> {
    const cognitoId = this.getCognitoId();
    const url = `${this.apiUrl}/checkUp/${cognitoId}/checkUpSave`;
    const headers = this.getHeaders();
    return this.http.post<any>(url, data, { headers });
  }

  getDrVideoUrl(data: DrVideoRequest): Observable<DrVideoResponse> {
    const cognitoId = this.getCognitoId();
    const url = `${this.apiUrl}/drvideo/${cognitoId}/obtenerUrlFormulario`;
    const headers = this.getHeaders();
    return this.http.post<DrVideoResponse>(url, data, { headers });
  }

}
